// extracted by mini-css-extract-plugin
module.exports = {"pendingContactContainer":"pendingContact_pendingContactContainer__dEJMQ","separator":"pendingContact_separator___76E4"};